"use client";

import { useIsClient } from "@/hooks/use-is-client";
import Script from "next/script";

export function BootstrapProvider({ children }: { children: React.ReactNode }) {
    const isClient = useIsClient();

    return (
        <>
            {isClient && (
                <Script
                    src="https://cdn.jsdelivr.net/npm/bootstrap@5.3.2/dist/js/bootstrap.bundle.min.js"
                    strategy="afterInteractive"
                />
            )}
            {children}
        </>
    );
}
